import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StoreService from 'scaleflow/services/store';
import type IntlService from 'ember-intl/services/intl';
import type IdeaModel from 'scaleflow/models/idea';

type Tab = {
  label: string;
  key: string;
  route: string;
};

export default class BacklogIdeasIdeaController extends Controller {
  @service declare router: RouterService;
  @service declare intl: IntlService;
  @service('beta-toggle') declare betaService: any;
  @service('organisation') declare orgService: any;
  @service declare initiatives: any;
  @service declare store: StoreService;

  declare model: IdeaModel;

  @tracked summaryPanelIsOpen = true;

  get leftPanelColSpan() {
    return this.summaryPanelIsOpen ? 'col-span-8' : 'col-span-11';
  }

  get idea() {
    return this.model;
  }

  get tabs(): Tab[] {
    return [
      {
        label: this.intl.t('dictionary.description'),
        route: 'backlog.ideas.idea.description',
        key: 'description',
      },
    ];
  }

  @action
  isActive(tab: Tab) {
    return this.router.currentRouteName?.includes?.(tab.key);
  }

  @action
  setIdeaStatus(e: { key: string; value: string }) {
    this.model.status = e.value;
    void this.model.save();
  }

  @action
  toggleSummaryPanel() {
    this.summaryPanelIsOpen = !this.summaryPanelIsOpen;
  }

  @action
  goToIdea(e: IdeaModel) {
    const currentRouteName = this.router.currentRoute?.name;
    this.router.transitionTo(currentRouteName, e.id!);
  }
}
